/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { getDetailQuestionsAnswered, getDetailAverageInView, getDetailUniqueEngagedUsers, getDetailRevenueMetrics, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
// component
import DataDetailPage from 'pages/dashboard/analytics/detail/detail';



/* ========== ~~~~~~~~~~ ANALYTICS DETAIL : CONTAINER ~~~~~~~~~~ ========== */
//column head example {total: '', [`2019-01-01`]: 'Jan 1', [`2019-01-02`]: 'Jan 2', [`2019-01-03`]: 'Jan 3' }
//row of data example  { rank: '#1', topquestion: 'Which vitamin is essential for nervous system', answers: '3,765', embed: <Link type={`internal`} text={``} color={`primary`} action={`dashboard/`} icon={<Icon name={`external-link-alt`} />} />  }
const mapStateToProps = ({ homeState, detailViewStatus, accountData, sessionStatus  }) => {

    const { homeAnalyticsData, homeAnalyticsStatus } = homeState;
    return {

        devices: detailViewStatus.devices,
        selectedDevices: detailViewStatus.selectedDevices,

        countries: detailViewStatus.countries,
        selectedCountries: detailViewStatus.selectedCountries,
        ronSites: detailViewStatus.ronSites,
        sites: accountData.sites,
        selectedSites: detailViewStatus.selectedSites,
        selectedRevenueType: homeAnalyticsStatus.selectedRevenueType,

        embeds: detailViewStatus.embeds,
        selectedEmbeds: detailViewStatus.selectedEmbeds,

        dateRange: detailViewStatus.dateRange,

        questionsAnsweredDetail: detailViewStatus.questionsAnsweredDetail,
        questionsAnsweredDetailFetching: detailViewStatus.questionsAnsweredDetailFetching,

        averageInViewDetail: detailViewStatus.averageInViewDetail,
        averageInViewDetailFetching: detailViewStatus.averageInViewDetailFetching,

        uniqueEngagedUsersDetail: detailViewStatus.uniqueEngagedUsersDetail,
        uniqueEngagedUsersDetailFetching: detailViewStatus.uniqueEngagedUsersDetailFetching,

        cpmDetail: detailViewStatus.cpmDetail,
        impressionDetail: detailViewStatus.impressionDetail,
        revenueDetail: detailViewStatus.revenueDetail,
        fetchingRevenue: detailViewStatus.fetchingRevenue,

        accountUUID: sessionStatus.accountUUID
    }};

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),

    getDetailQuestionsAnswered: (paramString) => dispatch(getDetailQuestionsAnswered(paramString)),
    getDetailAverageInView: (paramString) => dispatch(getDetailAverageInView(paramString)),
    getDetailUniqueEngagedUsers: (paramString) => dispatch(getDetailUniqueEngagedUsers(paramString)),
    clearDetailState: () => dispatch(clearDetailState()),

    getDetailRevenueMetrics: (paramString, dataType) => dispatch(getDetailRevenueMetrics(paramString, dataType))

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DataDetailPage);
